/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:15
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-21 16:02:05
 * @FilePath: \crm-product\found\views\tpm\views\budget\budget_fee\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '../../../../../components/table_page';
import Form from './form';
import DetailForm from './form/detail.vue';
import ChangeForm from './form/form-change';
import AdjustmentForm from './form/form-edit-adjust';
import ImportForm from './form/import_form.vue';
import * as utils from '../../../../../utils/index';
import EnableRemarkForm from './form/enable-remark';
import LogDetailForm from './log/detail.vue';

export default {
  name: 'investment_type',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
    DetailForm,
    ChangeForm,
    AdjustmentForm,
    ImportForm,
    EnableRemarkForm,
    LogDetailForm,
  },
  created() {
    this.getConfigList('tpm_fee_budget');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      } else if (val.code === 'detail') {
        this.formName = 'DetailForm';
        this.modalConfig = {
          title: '明细',
          width: '80%',
        };

        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
          feeBudgetCode: row.feeBudgetCode,
        };

        this.openDrawer();
      } else if (val.code === 'change') {
        this.formName = 'ChangeForm';
        this.modalConfig = {
          title: '变更',
          width: '60%',
        };

        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };

        this.openDrawer();
      } else if (val.code === 'adjustment') {
        this.formName = 'AdjustmentForm';
        this.modalConfig = {
          title: '调整',
          width: '60%',
        };

        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };

        this.openDrawer();
      } else if (val.code === 'tpm_fee_budget_change_import') {
        this.formName = 'ImportForm';
        this.modalConfig = {
          title: '导入文件',
          width: '800px',
          height: '60vh',
        };
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
          exportMessage: '',
          sid: utils.getUuid(32, 16),
        };
        this.modalConfig = {
          ...this.modalConfig,
        };
        this.openModal();
      } else if (val.code === 'tpm_fee_budget_change_export') {
        const a = document.createElement('a');
        a.href = '/tpm/v1/tpmFeeBudgetController/improt/exportTemplate';
        document.body.appendChild(a);
        a.click(); // 下载
        URL.revokeObjectURL(a.href); // 释放URL 对象
        document.body.removeChild(a); // 删除 a 标签
      } else if (val.code === 'enable' || val.code === 'disable') {
        if (!this.selection.length) {
          return this.$message({
            type: 'warning',
            message: '请选择要操作的数据',
          });
        }
        this.formName = 'EnableRemarkForm';
        this.modalConfig = {
          title: val.code === 'enable' ? '请确认启用数据?' : '请确认停用数据?',
          width: '50%',
          height: '400px',
        };
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          selection: this.selection,
        };
        this.modalConfig = {
          ...this.modalConfig,
        };
        this.openModal();
      } else if (val.code === 'info_logs') {
        this.formName = 'LogDetailForm';
        this.modalConfig = {
          title: '日志详情',
          width: '80%',
        };
        this.formConfig = {
          ...this.formConfig,
          budgetId: row.id,
        };
        this.modalConfig = {
          ...this.modalConfig,
        };
        this.openDrawer();
      }
    },
  },
};
